export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 9_01.6cb92acf.jpg";